import { createAsyncThunk } from "@reduxjs/toolkit";
import { getLocalData } from "../data";

const getDataClimats = createAsyncThunk("jamaslens/getDataClimats", async () => {
    const data = await getLocalData();
    return data.listC;
});

const getDataProjets = createAsyncThunk("jamaslens/getDataProjets", async () => {
    const data = await getLocalData();
    return data.listP;
});

const getDataComptes = createAsyncThunk("jamaslens/getDataComptes", async () => {
    const data = await getLocalData();
    return data.comptes;
});

const getDataCommandes = createAsyncThunk("jamaslens/getDataCommandes", async () => {
    const data = await getLocalData();
    return data.commandes;
});

const getPanier = createAsyncThunk("jamaslens/getPanier", async () => {
    const data = await getLocalData();
    return data.panier;
});

const addToPanier = createAsyncThunk("jamaslens/addToPanier", async (obj) => {
    const data = await getLocalData();
    data.panier.push(obj);
    return obj;
});

const updateCartItem = createAsyncThunk("jamaslens/updateCartItem", async (obj) => {
    const data = await getLocalData();
    const index = data.panier.findIndex(item => item.id === obj.id);
    if (index !== -1) {
        data.panier[index] = obj;
    }
    return obj;
});

const deleteCartItem = createAsyncThunk("jamaslens/deleteCartItem", async (id) => {
    const data = await getLocalData();
    data.panier = data.panier.filter(item => item.id !== id);
    return id;
});

const addClimatisseur = createAsyncThunk("jamaslens/addClimatisseur", async (obj) => {
    const data = await getLocalData();
    data.listC.push(obj);
    return obj;
});

const updateClimatisseur = createAsyncThunk("jamaslens/updateClimatisseur", async (obj) => {
    const data = await getLocalData();
    const index = data.listC.findIndex(item => item.id === obj.id);
    if (index !== -1) {
        data.listC[index] = obj;
    }
    return obj;
});

const deleteClimatisseur = createAsyncThunk("jamaslens/deleteClimatisseur", async (id) => {
    const data = await getLocalData();
    data.listC = data.listC.filter(item => item.id !== id);
    return id;
});

const getClimatisseurInfo = createAsyncThunk("jamaslens/getClimatisseurInfo", async (id) => {
    const data = await getLocalData();
    return data.listC.find(item => item.id === id);
});

const addProjet = createAsyncThunk("jamaslens/addProjet", async (obj) => {
    const data = await getLocalData();
    data.listP.push(obj);
    return obj;
});

const updateProjet = createAsyncThunk("jamaslens/updateProjet", async (obj) => {
    const data = await getLocalData();
    const index = data.listP.findIndex(item => item.id === obj.id);
    if (index !== -1) {
        data.listP[index] = obj;
    }
    return obj;
});

const deleteProjet = createAsyncThunk("jamaslens/deleteProjet", async (id) => {
    const data = await getLocalData();
    data.listP = data.listP.filter(item => item.id !== id);
    return id;
});

const getProjetInfo = createAsyncThunk("jamaslens/getProjetInfo", async (id) => {
    const data = await getLocalData();
    return data.listP.find(item => item.id === id);
});

const addCompte = createAsyncThunk("jamaslens/addCompte", async (obj) => {
    const data = await getLocalData();
    data.comptes.push(obj);
    return obj;
});

const updateCompte = createAsyncThunk("jamaslens/updateCompte", async (obj) => {
    const data = await getLocalData();
    const index = data.comptes.findIndex(item => item.id === obj.id);
    if (index !== -1) {
        data.comptes[index] = obj;
    }
    return obj;
});

const deleteCompte = createAsyncThunk("jamaslens/deleteCompte", async (id) => {
    const data = await getLocalData();
    data.comptes = data.comptes.filter(item => item.id !== id);
    return id;
});

const addCommande = createAsyncThunk("jamaslens/addCommande", async (obj) => {
    const data = await getLocalData();
    data.commandes.push(obj);
    return obj;
});

const updateCommande = createAsyncThunk("jamaslens/updateCommande", async (obj) => {
    const data = await getLocalData();
    const index = data.commandes.findIndex(item => item.id === obj.id);
    if (index !== -1) {
        data.commandes[index] = obj;
    }
    return obj;
});

const deleteCommande = createAsyncThunk("jamaslens/deleteCommande", async (id) => {
    const data = await getLocalData();
    data.commandes = data.commandes.filter(item => item.id !== id);
    return id;
});

const patchCompte = createAsyncThunk("jamaslens/patchCompte", async (obj) => {
    const data = await getLocalData();
    const index = data.comptes.findIndex(item => item.id === obj.id);
    if (index !== -1) {
        data.comptes[index] = { ...data.comptes[index], ...obj };
        return data.comptes[index];
    }
    return obj;
});

export {
    getDataClimats, getDataProjets, getDataComptes, getDataCommandes, getPanier, addToPanier, deleteCartItem, updateCartItem,
    addClimatisseur, updateClimatisseur, deleteClimatisseur, getClimatisseurInfo,
    addProjet, updateProjet, deleteProjet, getProjetInfo,
    addCompte, updateCompte, patchCompte, deleteCompte,
    addCommande, updateCommande, deleteCommande
};